export default {"src":"https://fishbrain.com/_next/static/media/arizona.4f4411fe.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};